import React, { FC, ReactElement } from 'react';
import { Route } from 'react-router';

import {
  GetActiveClientByAttrComponent,
  Client,
  GetActiveClientByAttrQueryVariables,
  ClientStatus,
} from 'api/public';
import { ErrorPage, QueryManager } from 'components';

interface IProps {
  variables: GetActiveClientByAttrQueryVariables;
  children: (client: Client) => ReactElement;
}

const GetActiveClientByAttr: FC<IProps> = ({ variables, children }) => {
  return (
    <GetActiveClientByAttrComponent variables={variables}>
      {props => {
        return (
          <QueryManager {...props}>
            {({ data }) => {
              if (!data) {
                return null;
              }
              if (!data.getActiveClientByAttr) {
                return <Route component={() => <ErrorPage type="no-client" />} />;
              }
              const { getActiveClientByAttr } = data;
              const isValidClient = getActiveClientByAttr.client_status !== ClientStatus.Disabled;
              if (!isValidClient) {
                return <Route component={() => <ErrorPage type="no-client" />} />;
              }
              return children(getActiveClientByAttr);
            }}
          </QueryManager>
        );
      }}
    </GetActiveClientByAttrComponent>
  );
};

export default GetActiveClientByAttr;
